export const isChannel = (output) => output.cid != null;
